import { AddKegiatanSosialPayload } from "../../../../models/KegiatanSosial";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { allKegiatanSosialKey } from "../../queries/KegiatanSosial/useFetchAllKegiatanSosial";
import getQueryClient from "../../queryClient";

export async function addKegiatanSosial(data: AddKegiatanSosialPayload) {
  const res = await ApiClient.post(`/AddKegiatanSosial`, data);
  return res.data;
}

export const useAddKegiatanSosial = mutationWrapper(addKegiatanSosial, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allKegiatanSosialKey);
  },
});
